import { Link } from "react-router-dom";
import { CONTACT, openWhatsApp } from "@/data/site";
import { ArrowUpRight, Phone, Mail, MessageCircle } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      className="relative bg-ink-950 border-t border-white/10 pt-24 pb-10 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        {/* Top CTA row */}
        <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="lg:col-span-7">
            <div className="text-[10px] tracking-[0.3em] text-edge uppercase mb-4">
              Let's build
            </div>
            <h3 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95]">
              Smart Insulation.
              <br />
              <span className="text-edge">Strong Protection.</span>
            </h3>
          </div>
          <div className="lg:col-span-5 flex flex-col justify-end gap-4">
            <Link
              to="/contact"
              className="group flex items-center justify-between border border-white/20 hover:border-edge px-6 py-5 transition-colors"
              data-testid="footer-cta-quote"
            >
              <span className="font-display uppercase tracking-wide text-lg">
                Get a Free Quote
              </span>
              <ArrowUpRight className="w-6 h-6 text-edge group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
            <button
              onClick={() => openWhatsApp()}
              className="group flex items-center justify-between border border-white/20 hover:border-edge px-6 py-5 text-left transition-colors"
              data-testid="footer-cta-whatsapp"
            >
              <span className="font-display uppercase tracking-wide text-lg">
                Chat on WhatsApp
              </span>
              <MessageCircle className="w-6 h-6 text-edge" />
            </button>
          </div>
        </div>

        {/* Middle links */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 py-14 border-b border-white/10">
          <div>
            <div className="text-[10px] tracking-[0.3em] text-slateink uppercase mb-4">
              Explore
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-edge">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-edge">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-edge">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-edge">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-edge">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-edge">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] text-slateink uppercase mb-4">
              Products
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/products/air-bubble-insulation"
                  className="hover:text-edge"
                >
                  Air Bubble
                </Link>
              </li>
              <li>
                <Link
                  to="/products/xlpe-insulation"
                  className="hover:text-edge"
                >
                  XLPE
                </Link>
              </li>
              <li>
                <Link
                  to="/products/aluminium-foil-tape"
                  className="hover:text-edge"
                >
                  Foil Tape
                </Link>
              </li>
              <li>
                <Link
                  to="/products/air-bubble-packaging-roll"
                  className="hover:text-edge"
                >
                  Packaging Roll
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] text-slateink uppercase mb-4">
              Industries
            </div>
            <ul className="space-y-3 text-sm text-white/70">
              <li>Warehouses</li>
              <li>Factories</li>
              <li>Poultry Farms</li>
              <li>Cold Storage</li>
              <li>Logistics</li>
            </ul>
          </div>
          <div className="col-span-2 md:col-span-1 lg:col-span-3">
            <div className="text-[10px] tracking-[0.3em] text-slateink uppercase mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-edge" />
                <a href={`tel:${CONTACT.phone}`} className="hover:text-edge">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-edge" />
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-edge break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="w-4 h-4 text-edge" />
                <button
                  onClick={() => openWhatsApp()}
                  className="hover:text-edge"
                >
                  WhatsApp
                </button>
              </li>
              <li className="text-white/60 text-xs mt-4">
                Currently serving Bihar · Pan-India projects on request
              </li>
            </ul>
          </div>
        </div>

        {/* Giant type footer */}
        <div className="py-16 select-none">
          <div className="font-display font-black text-white/[0.06] text-[18vw] leading-none tracking-tighter uppercase">
            Thermo Edge
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8 border-t border-white/10 text-xs text-slateink">
          <div>
            © {new Date().getFullYear()} Thermo Edge Insulation. Authorized
            dealer & solution provider.
          </div>
          <div className="tracking-widest uppercase">thermoedge.co.in</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
